import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export class CustomValidators {
  private static handledPhoneCountryCodes(): Array<CountryCode> {
    return ["FR", "GB"];
  }

  public static zodTimeZone(schema: z.ZodString) {
    return schema.refine(
      (value) => {
        try {
          Intl.DateTimeFormat(undefined, { timeZone: value });
          return true;
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
          return false;
        }
      },
      { message: "Invalid timezone" },
    );
  }

  public static zodPhone(schema: z.ZodString) {
    return schema.refine((value) => {
      for (const countryCode of CustomValidators.handledPhoneCountryCodes()) {
        if (isValidPhoneNumber(value, countryCode)) {
          return true;
        }
      }

      return false;
    }, "phoneNumber");
  }
}
